import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLeaveStatementsReport extends Layout {
    checkboxEmailStatements: Checkbox;
    checkboxPageBreakPayee: Checkbox;
    checkboxPrintBannerPage: Checkbox;
    excludabletextboxDivisionId: ExcludableTextbox;
    excludabletextboxPayeeId: ExcludableTextbox;
    excludabletextboxTerminalId: ExcludableTextbox;
    settlementLeaveStatementsReportDatasource: DataSource;
    textboxDateType: Textbox;
    textboxLeaveStatementsCheckDate: Textbox;
}
